import classnames from 'classnames';
import React from 'react';
import { includes } from 'lodash';
import PropTypes from 'prop-types';
import styles from './cta.scss';
import ArrowRightLongIcon from '../../../../../../icons/compiled/components/ArrowRightLongIcon';
import TriangleIcon from '../../../../../../icons/compiled/components/TriangleIcon';
import { TwitterButton } from '../../social-buttons/twitter';
import { YoutubeButton } from '../../social-buttons/youtube';
import { FacebookButton } from '../../social-buttons/facebook';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import { InlineIcon } from '../../../../../inline-icon/inline-icon';
export class CardCTA extends React.Component {
    renderSocialButton() {
        const { cardData, labels, isAccessible } = this.props;
        const { facebookButtonTitle, youtubeButtonTitle, twitterButtonTitle } = labels;
        switch (cardData.network) {
            case 'twitter':
                return (React.createElement(TwitterButton, { isAccessible: isAccessible, twitterButtonTitle: twitterButtonTitle, cardData: cardData }));
            case 'youtube':
                return (React.createElement(YoutubeButton, { isAccessible: isAccessible, youtubeButtonTitle: youtubeButtonTitle, cardData: cardData }));
            case 'facebook':
                return (React.createElement(FacebookButton, { isAccessible: isAccessible, facebookButtonTitle: facebookButtonTitle, cardData: cardData }));
            default:
                return null;
        }
    }
    isLiveVideo() {
        const { itemType } = this.props.cardData;
        return itemType === ItemType.ItemLive;
    }
    renderDefaultCTA() {
        const { type, buttonLabel } = this.props.cardData;
        const isArrowIcon = includes([VIDEO_CARD_TYPES.CUSTOM, VIDEO_CARD_TYPES.PRODUCT], type);
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.label, "data-hook": "action-card-action-text" },
                this.isLiveVideo() && React.createElement("div", { className: styles.circle }),
                buttonLabel),
            React.createElement("div", { className: styles.icon }, isArrowIcon ? (React.createElement(InlineIcon, { icon: React.createElement(ArrowRightLongIcon, null), className: styles['icon-arrow'] })) : (React.createElement(InlineIcon, { icon: React.createElement(TriangleIcon, null), className: styles['icon-play'] })))));
    }
    render() {
        return this.props.cardData.type === VIDEO_CARD_TYPES.SOCIAL ? (React.createElement("div", { className: classnames(styles.container, styles['with-social-button']), "data-hook": "action-card-action-text" }, this.renderSocialButton())) : (this.renderDefaultCTA());
    }
}
CardCTA.propTypes = {
    cardData: PropTypes.object,
    isAccessible: PropTypes.bool,
    labels: PropTypes.object,
};
CardCTA.defaultProps = {
    labels: {},
};
//# sourceMappingURL=cta.js.map